<template>
  <!-- Main template setting up cross-site UI and components -->
  <div class="main-container">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
/** Importing fonts */
@font-face {
  font-family: oxygen-light;
  src: url("/fonts/Oxygen-Light.ttf");
}
@font-face {
  font-family: oxygen-regular;
  src: url("/fonts/Oxygen-Regular.ttf");
}
@font-face {
  font-family: oxygen-bold;
  src: url("/fonts/Oxygen-Bold.ttf");
}

/** Applying fonts and styles globally */
h1 {
  color: var(--mediumgreen);
  font-family: oxygen-bold;
}

h2,
h3 {
  font-family: oxygen-bold;
}

p,
a,
div,
label,
span,
select,
option {
  font-family: oxygen-regular;
}

p,
span,
label,
h1,
h2,
h3,
h4,
h5 {
  // Decision by UI designer to have no hyphenation
  hyphens: auto;
  overflow-wrap: break-word;
}

a {
  text-decoration: none !important;
  color: var(--deepgreen) !important;
}

/** Defining global colors */
:root {
  --deepgreen: rgb(0, 100, 50);
  --deepgreenopaque: rgba(0, 100, 50, 0.32);
  --mediumgreen: rgb(130, 193, 122);
  --darkgreen: rgb(0, 49, 39);
  --mediumgreenopaque: #e5efea;
  --lightgrey: rgb(239, 239, 239);
  --mediumgrey: rgb(153, 153, 153);
  --darkgrey: rgb(100, 100, 100);
  --lightgreyopaque: rgba(239, 239, 239, 0.9);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /** Define colors for vue3-datepicker */
  --vdp-hover-bg-color: var(--deepgreen);
  --vdp-selected-bg-color: var(--deepgreen);
}

/* Defining page setup and background images (decorations) */
.main-container {
  min-height: 80vh;
  margin: 30px 5% 70px 5%;
}
.card {
  background: transparent !important;
  border: none !important;
}

/* Defining styles of info-pages */
.page-title {
  margin-bottom: 30px;
  color: var(--deepgreen);
}
p.page-description {
  font-size: 1.2em;
  color: var(--deepgreen);
}
.inherit-link-styling a,
.info-page a {
  cursor: pointer;
  font-family: oxygen-bold;
  &:hover,
  &:focus {
    text-decoration: underline !important;
  }
}
.info-page h2 {
  color: var(--deepgreen);
  margin-top: 30px !important;
}
.info-page h3 {
  margin-top: 20px !important;
  font-size: 1.2em;
}
.info-page ul,
.input-contact-info ul {
  list-style: none;
}
.info-page ul li::before,
.input-contact-info ul li::before,
.product-info .fact-box ul li::before {
  content: "\25CF"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: var(--deepgreen); /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  width: 1.5em; /* Also needed for space (tweak if needed) */
  margin-left: -1.5em; /* Also needed for space (tweak if needed) */
  border: none;
  font-size: 1.25em;
}
.fact-box {
  background-color: var(--mediumgreenopaque);
  padding: 20px;
}

/* Defining styles of buttons */
.btn {
  border-radius: 0px !important;
  &:hover,
  &:focus {
    transform: scale(1.05);
  }
}
.btn:focus {
  box-shadow: none !important;
}
.btn-close {
  opacity: 0.8 !important;
}
.btn.disabled {
  pointer-events: unset;
  cursor: not-allowed;
}
.btn-primary {
  background-color: var(--deepgreen) !important;
  color: white !important;
  border-color: var(--deepgreen) !important;
}
.btn-secondary {
  background-color: white !important;
  color: var(--deepgreen) !important;
  border: 1px solid var(--deepgreen) !important;
}

/* Defining media queries for responsiveness */
@media only screen and (min-width: 768px) {
  p.page-description {
    font-size: 1.35em;
  }
  p.page-description-shrink {
    padding-right: 25%;
  }
  .col.left-panel-full-page {
    flex: unset;
    width: 40%;
  }
  .col.right-panel-full-page {
    flex: unset;
    width: 60%;
  }
}
</style>
